import { QUERY_AB_TESTER } from 'config/types/action';

/**
 * State slice reducer for menu related actions.
 * @param {object}   state   menu state slice
 * @param {string}   type
 * @param {*}        payload
 * @returns {object}
 */
export default function abTesterReducer(state = {}, { type, payload }) {
  switch (type) {
    case QUERY_AB_TESTER:
      return {
        ...state,
        isLoading: payload.isLoading,
        isInExperimentGroup: payload.isInExperimentGroup,
        wasQueried: payload.wasQueried,
      };
    default:
      return state;
  }
}
